export default __webpack_public_path__ + "static/Postcall_Logo-30fdb192d01de747604f10cbadc053e6.png";